/**
 * On-device Apple Intelligence helper.
 *
 * Currently a stub — the @react-native-ai/apple package requires the iOS 26
 * Xcode SDK to compile (it references `SpeechTranscriber`) which isn't yet
 * broadly available. Until the package stabilises all calls return null and
 * every feature falls back to its static template.
 *
 * The API surface is intentionally identical to the full implementation so
 * that swapping in a working SDK later requires zero changes at call sites:
 *
 *   const text = await generateWithApple('...', 20);
 *   if (!text) { /* use fallback *\/ }
 */

export function isAppleIntelligenceAvailable(): boolean {
  return false;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function generateWithApple(
  _prompt: string,
  _maxTokens = 60,
): Promise<string | null> {
  return null;
}
